import { useGLTF } from "@react-three/drei"
import { RigidBody } from "@react-three/rapier"
import { useEffect } from "react"
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader"
import FireflySwarm from "./FireflySwarm"
import { fireflyConfigs } from "../../model_data/lights"

useGLTF.preload('../../low_poly_environment_compressed-v1.glb')

export default function Landscape() {
    const landscape = useGLTF('./low_poly_environment_compressed-v1.glb', true, false, (loader) => {
        // Seems to work(Doesn't cause errors), but have no idea how to test
        // Have checked through network tab through inspect, but nothing seems to change
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.5/');
        dracoLoader.setDecoderConfig({ type: 'js' });
        loader.setDRACOLoader(dracoLoader);
    });
    
    useEffect(() => {
        // Traverse through all objects in the scene
        landscape.scene.traverse((child) => {
            
                child.receiveShadow = true;
                child.castShadow = true;
                child.matrixWorldNeedsUpdate = true;
                
                // If the mesh uses materials that need shadow support
                if (child.material) {
                    child.material.needsUpdate = true;
                }
        })
    }, [landscape])

    return (
        <>
            <RigidBody 
                type="fixed"
                colliders="trimesh"
                rotation-y={Math.PI / 2}
                castShadow
                receiveShadow
            >
                <primitive 
                    object={landscape.scene} 
                    position={[-14, -8, -42]} 
                    scale={[1, 1, 1]}
                    rotation-y={Math.PI / 2}
                />
            </RigidBody> 
            
            <FireflySwarm fireflyConfigs={fireflyConfigs} />
        </>
    )
}